'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class, _class2, _temp;

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _MobileTab = require('./MobileTab.scss');

var _MobileTab2 = _interopRequireDefault(_MobileTab);

var _reactScroll = require('react-scroll');

var _reactScroll2 = _interopRequireDefault(_reactScroll);

var _reactRedux = require('react-redux');

var _trip = require('redux/modules/trip');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  MobileTab: {
    displayName: 'MobileTab'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/TripDetail/MobileTab.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

var MobileTab = _wrapComponent('MobileTab')((_dec = (0, _reactRedux.connect)(function (state) {
  return {
    tab: state.trip.mobileTab,
    trip: state.trip.data
  };
}, { changeTab: _trip.changeTab }), _dec2 = (0, _reactCssModules2.default)(_MobileTab2.default), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(MobileTab, _Component);

  function MobileTab() {
    (0, _classCallCheck3.default)(this, MobileTab);
    return (0, _possibleConstructorReturn3.default)(this, (MobileTab.__proto__ || (0, _getPrototypeOf2.default)(MobileTab)).apply(this, arguments));
  }

  (0, _createClass3.default)(MobileTab, [{
    key: 'onSelectTab',
    value: function onSelectTab(tab) {
      // const bannerH = 240;
      // const priceH = 80;
      this.props.changeTab(tab);
      // window.scrollTo(0, bannerH - priceH);
      _reactScroll2.default.scroller.scrollTo(tab, {
        offset: -100,
        duration: 500,
        smooth: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          tab = _props.tab,
          trip = _props.trip;

      return _react3.default.createElement(
        'div',
        { styleName: 'container' },
        _react3.default.createElement(
          'ul',
          { styleName: 'tabs' },
          _react3.default.createElement(
            'li',
            { styleName: tab === 'overview' ? 'active' : 'non-active', onClick: this.onSelectTab.bind(this, 'overview') },
            _react3.default.createElement(
              'a',
              null,
              'Overview'
            )
          ),
          _react3.default.createElement(
            'li',
            { styleName: tab === 'detail' ? 'active' : 'non-active', onClick: this.onSelectTab.bind(this, 'detail') },
            _react3.default.createElement(
              'a',
              null,
              'Detail'
            )
          ),
          _react3.default.createElement(
            'li',
            { styleName: tab === 'review' ? 'active' : 'non-active', onClick: this.onSelectTab.bind(this, 'review') },
            _react3.default.createElement(
              'a',
              null,
              'Review',
              trip.reviews && trip.reviews.length > 0 && ' (' + trip.reviews.length + ')'
            )
          )
        )
      );
    }
  }]);
  return MobileTab;
}(_react2.Component), _class2.propTypes = {
  tab: _react2.PropTypes.string,
  trip: _react2.PropTypes.object,
  changeTab: _react2.PropTypes.func
}, _temp)) || _class) || _class));

exports.default = MobileTab;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TripDetail/MobileTab.js
// module id = 1638
// module chunks = 0